import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { NgForm } from '@angular/forms';
import { RoleDetailsRest } from '../role-details/role-details.rest';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'role-modal-add',
  templateUrl: './role-modal-add.component.html'
})
export class RoleModalComponent implements OnInit {
  private isSaving = false;
  public roleName: string;

  @ViewChild('roleForm') roleForm: NgForm;

  @ViewChild(ModalComponent) private modal: ModalComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  constructor(
    private rest: RoleDetailsRest,
    private permissionService: PermissionsService) {
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.roleForm.valid) {
      this.confirm();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.modal.title = 'Dodaj nową rolę';
  }

  openForAdd() {
    this.modal.openWithCustomSize({ height: '25vh' });
  }
  
  public confirm() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    this.rest.createNewRole(this.roleName).subscribe((result: string) => {
      if(result){
        this.isSaving = false;
        this.closeModal();
        this.onSuccess.emit(result);
      }
    });
  }

  public closeModal() {
    this.modal.close();
  }
}
